/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CashAdvanceRequestStatus {
    PendingOwner = 0,
    RejectedOwner = 1,
    PendingUser = 2,
    RejectedUser = 3,
    Processed = 4,
    Cancelled = 5,
}
